module.exports = __webpack_public_path__ + "img/idea.120b3d97.png";